import applyCaseMiddleware from "axios-case-converter"
import axios from "axios"

const baseURL = process.env.REACT_APP_API_URL

export const http = applyCaseMiddleware(axios.create({ baseURL }))
export const fetcher = request => http.request(request)
